import { Component, OnInit } from '@angular/core';
import { MapCoverage, CoverageResult } from 'src/app/model/Coverage';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-coverage-content',
  templateUrl: './coverage-content.component.html',
  styleUrls: ['./coverage-content.component.css']
})
export class CoverageContentComponent implements OnInit {
  lat: number = 6.4281;
  lng: number = 3.4219;
  zoom: number = 15;
  modalContent: string;
  isVisible: boolean = false;

  constructor(private reportService: ReportsService) { }

  ngOnInit() {

  }

  async mapClicked(event) {
    let lat = event.coords.lat;
    let lng = event.coords.lng;

    await this.GetMapCoverage(lat, lng);

  }

  async GetMapCoverage(lat, lng) {

    if (!lat || !lng) {

      this.modalContent = `Service is not available in the location specified`;
      this.isVisible = true;
      return;
    }


    let res = await this.reportService.GetMapCoverage(lat, lng).toPromise();

    if (!res || ! res.Result || !res.Status || res.Result.length < 1) {

      this.modalContent = `Service is not available in the location specified`;
      this.isVisible = true;
      return;
    }

    let result: MapCoverage[] = res.Result;
    let data = result.filter(a => a.DeviceCoverage.length > 0);

    if (!data || data.length < 1) {

      this.modalContent = `Service is not available in the location specified`;
      this.isVisible = true;
      return;
    }


    let coverageList: CoverageResult[] = [];

    data.forEach(a => {

      a.DeviceCoverage.forEach(b => {

        if (b.Status_Excellent) {

          if (coverageList.length < 1) {

            let coverage: CoverageResult = {} as CoverageResult;
            coverage.Name = b.DeviceName;
            coverage.Status = "Excellent";
            coverageList.push(coverage);
          } else {

            let exists: CoverageResult = coverageList.find(a => a.Name == b.DeviceName);
            if (!exists) {
              let coverage: CoverageResult = {} as CoverageResult;
              coverage.Name = b.DeviceName;
              coverage.Status = "Excellent";
              coverageList.push(coverage);

            } else {

              if (exists.Status != "Excellent") {

                let filteredcoverageList = coverageList.filter(a => a.Name != exists.Name);
                let coverage: CoverageResult = {} as CoverageResult;
                coverage.Name = b.DeviceName;
                coverage.Status = "Excellent";
                filteredcoverageList.push(coverage);
                coverageList = filteredcoverageList;

              }

            }

          }

        }

        else if (b.Status_Good) {
          //
          if (coverageList.length < 1) {

            let coverage: CoverageResult = {} as CoverageResult;
            coverage.Name = b.DeviceName;
            coverage.Status = "Good";
            coverageList.push(coverage);
          } else {

            let exists: CoverageResult = coverageList.find(a => a.Name == b.DeviceName);
            if (!exists) {
              let coverage: CoverageResult = {} as CoverageResult;
              coverage.Name = b.DeviceName;
              coverage.Status = "Good";
              coverageList.push(coverage);

            } else {

              if (exists.Status != "Excellent" && exists.Status != "Good") {
                let filteredcoverageList = coverageList.filter(a => a.Name != exists.Name);
                let coverage: CoverageResult = {} as CoverageResult;
                coverage.Name = b.DeviceName;
                coverage.Status = "Good";
                filteredcoverageList.push(coverage);
                coverageList = filteredcoverageList;

              }

            }

          }

        }

        else if (b.Status_Fair) {

          if (coverageList.length < 1) {

            let coverage: CoverageResult = {} as CoverageResult;
            coverage.Name = b.DeviceName;
            coverage.Status = "Fair";
            coverageList.push(coverage);
          } else {

            let exists: CoverageResult = coverageList.find(a => a.Name == b.DeviceName);
            if (!exists) {
              let coverage: CoverageResult = {} as CoverageResult;
              coverage.Name = b.DeviceName;
              coverage.Status = "Fair";
              coverageList.push(coverage);

            } else {

              if (exists.Status != "Excellent" && exists.Status != "Good" && exists.Status != "Fair") {
                let filteredcoverageList = coverageList.filter(a => a.Name != exists.Name);
                let coverage: CoverageResult = {} as CoverageResult;
                coverage.Name = b.DeviceName;
                coverage.Status = "Fair";
                filteredcoverageList.push(coverage);
                coverageList = filteredcoverageList;
              }

            }

          }

        }

        else if (b.Status_Poor) {

          if (coverageList.length < 1) {

            let coverage: CoverageResult = {} as CoverageResult;
            coverage.Name = b.DeviceName;
            coverage.Status = "Poor";
            coverageList.push(coverage);
          } else {

            let exists: CoverageResult = coverageList.find(a => a.Name == b.DeviceName);
            if (!exists) {
              let filteredcoverageList = coverageList.filter(a => a.Name != exists.Name);
              let coverage: CoverageResult = {} as CoverageResult;
              coverage.Name = b.DeviceName;
              coverage.Status = "Poor";
              filteredcoverageList.push(coverage);
              coverageList = filteredcoverageList;

            }

          }

        }
      })

    });

    if (!coverageList || coverageList.length < 1) {

      this.modalContent = `Service is not available in the location specified`;
      this.isVisible = true;
      return;
    }

    var value = `<b>Recommended Device with Status:<b/><br/><br/>`;
    coverageList.forEach(a => {
      value += `Device : ${a.Name} Coverage Strength : ${a.Status} <br/>`;
    });

    this.modalContent = value;
    this.isVisible = true;
  }



  handleOk(): void {
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

}
